<footer>
  <div class="copyright">
    &copy; {{ today | date: 'yyyy' }}, Penn Emblem
  </div>
</footer>
